module.exports = __webpack_public_path__ + "static/media/US_Payslip_1.d4c8c1c3.png";